import View from './View';

class EditView extends View {
    constructor(name) {
        super(name);
        this._type = 'EditView';
    }
}

export default EditView;



/** WEBPACK FOOTER **
 ** ./~/ng-annotate-loader/loader.js!./~/admin-config/lib/View/EditView.js
 **/